import { useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viSpinnerThird, viWebhooks } from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function AddWebhookItem({ webhook, dispatch, ...props }) {
  const [pending, setPending] = useState(false);

  const handleAddWebhook = () => {
    if (webhook.id) {
      setPending(true);

      Promise.resolve(Api.postWebhookInboundRoute(webhook, props.inbound))
        .then(() => dispatch({ type: "addWebhook", webhook }))
        .finally(() => setPending(false));
    }
  };

  return (
    <ListItem disablePadding key={webhook.id} sx={{ minHeight: 44 }}>
      <ListItemButton onClick={() => handleAddWebhook(webhook)} disabled={pending} sx={{ minHeight: 44 }}>
        <ListItemAvatar sx={{ minWidth: 34 }}>
          <Avatar text={webhook.name} icon={viWebhooks} px={24} />
        </ListItemAvatar>
        <ListItemText primary={webhook.name} />
        {pending && (
          <ListItemIcon sx={{ minWidth: 16 }}>
            <Valkyrie icon={viSpinnerThird} spin />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}

AddWebhookItem.propTypes = {
  inbound: PropTypes.object,
  webhook: PropTypes.object,
  dispatch: PropTypes.func,
};

export default AddWebhookItem;
